import {ProcessedOtherContent, ProcessedTourOperator} from "./contentfulModel.ts";
import React from "react";

interface TourCatalogAdditionalContentProps {
    tourOperator: ProcessedTourOperator;
    otherContent: ProcessedOtherContent;
    tourCatalog: ProcessedOtherContent;
    goToSlide: (slideIndex: number) => void;
}
const getTickIcon = (color: string) => (
    <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.33702 12.6191C6.83476 13.127 6.0231 13.127 5.52084 12.6191L0.376575 7.41827C-0.125525 6.91038 -0.125525 6.08962 0.376575 5.58173C0.878754 5.07384 1.69282 5.07384 2.19508 5.58173L6.39277 9.86021L15.8071 0.380919C16.3094 -0.126973 17.121 -0.126973 17.6233 0.380919C18.1256 0.888811 18.1256 1.70956 17.6233 2.21746L7.33702 12.6191Z"
            fill={color}/>
    </svg>
)

// Simple helper to render rich text nodes
const renderRichText = (tick: any, node: any) => {
    if (!node) return null;

    // Process document node
    if (node.nodeType === 'document') {
        return (
            <div className="rich-text">
                {node.content.map((contentNode: any, i: number) => renderRichText(tick,contentNode))}
            </div>
        );
    }

    // Process paragraph node
    if (node.nodeType === 'paragraph') {
        return (
            <p key={Math.random()} className="text-sm leading-6.5">
                {node.content.map((textNode: any, i: number) => renderRichText(tick,textNode))}
            </p>
        );
    }

    if(node.nodeType === 'unordered-list'){
        return (
            <ul key={Math.random()} className="mb-4">
                {node.content.map((textNode: any, i: number) => renderRichText(tick,textNode))}
            </ul>
        );

    }

    if(node.nodeType === 'list-item'){
        return (
            <li key={Math.random()} className="mb-4 flex items-center gap-4">
                <div>
                    {tick}
                </div>
                <div>{node.content.map((textNode: any, i: number) => renderRichText(tick,textNode))}
                </div>
            </li>
        );
    }

    // Process text node with marks
    if (node.nodeType === 'text') {
        let content = node.value;

        // Apply text formatting based on marks
        if (node.marks && node.marks.length > 0) {
            node.marks.forEach((mark: any) => {
                switch (mark.type) {
                    case 'bold':
                        content = <strong key={Math.random()}>{content}</strong>;
                        break;
                    case 'italic':
                        content = <em key={Math.random()}>{content}</em>;
                        break;
                    case 'underline':
                        content = <u key={Math.random()}>{content}</u>;
                        break;
                    default:
                        break;
                }
            });
        }

        return content;
    }

    return null;
};


// Arrow left icon component
const ArrowLeftIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
        <path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"/>
    </svg>
);

export const TourCatalogAdditionalContent = ({  tourOperator ,otherContent,tourCatalog, goToSlide}: TourCatalogAdditionalContentProps) => {

    const isMobile = window.innerWidth < 768;

    // Function to handle going back to index
    const handleBackToIndex = () => {

            goToSlide(1);

    };

    return (<div className="flex flex-col md:flex-row w-full h-full flex-col-reverse ">
        {/* Left Section - 45% width */}
        <div className="w-full md:w-[45%] p-8 h-full flex flex-col justify-between text-left md:pt-6 md:px-[70px]">
            <div>
            <div
                onClick={handleBackToIndex}
                className="bg-white md:bg-white ml-0 p-3 md:pl-4 rounded-xl absolute top-[20px] md:relative cursor-pointer bg-transparent flex items-center gap-2 text-black hover:underline top-3 md:top-auto md:mb-6 opacity-85 left-4 md:left-auto w-auto self-start md:max-w-60"
                style={{
                    boxShadow: isMobile ? "0px 4px 4px 0px #00000040" : ""
                }}
            >
                <ArrowLeftIcon/>
                <span className="text-sm font-semibold">Volver al índice</span>
            </div>
            {/* Tour Package Information */}
            <div className="mb-6 md:pt-0">
                <div
                    className="text-md uppercase md:text-xl md:font-medium mb-1 md:pt-6">{tourOperator.name}</div>
                <h2 className="text-xl md:text-2xl font-semibold md:font-semibold mb-1">
                    {otherContent.title}
                </h2>


                <div className="mt-4 md:mt-8 leading-6.5">
                    {renderRichText(getTickIcon(tourOperator.primaryColor),otherContent.content)}
                </div>
            </div>

        </div>
        { tourCatalog.partnerLogo ?
            <div>
                <img src={tourCatalog.partnerLogo.file} alt="Partner Logo" className="w-30 md:w-40 md:mt-10  md:block"/>
            </div> : null }
        </div>

        {/* Right Section - 55% width */}
        <div className="w-full md:w-[55%] h-[140px] md:h-full flex flex-col">
            <div className="h-full">
                <img crossOrigin="anonymous"
                     src={otherContent.mainImage?.file}
                     className="w-full h-full object-cover rounded-b-2xl md:rounded-r-none md:rounded-l-2xl"
                /><img crossOrigin="anonymous"
                       src={tourOperator.logoContrast.file}
                       className="w-40 absolute bottom-4 right-4"
                       alt={tourOperator.name}/>
            </div>
        </div>
    </div>)
}
